import axios from 'axios';
import { API_BASE_URL } from '@/config/serverApiConfig';

import errorHandler from './errorHandler';
import successHandler from './successHandler';
import CompanyList from './CompanyList';

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;

const request = {
  create: async ({ entity, options = {}, jsonData }) => {
    console.log('🚀 Create Request 🚀 ~ file: request.js ~ line 19 ~ create: ~ jsonData', jsonData);
    console.log("*****create *****"+ JSON.stringify(options));
// 💡 DESEMPAQUETAR: Si options trae un objeto 'params' interno (como pasa en Cliente)
    // extraemos sus propiedades para usarlas directamente.
    let actualOptions = { ...options };
    if (options && options.params && typeof options.params === 'object') {
      actualOptions = { ...options.params };
    }

    let query = '?';
    for (var key in actualOptions) {
      let value = actualOptions[key];
      
      // Si el valor interno sigue siendo un objeto (ej: { id: 1 }), sacamos su ID
      if (value && typeof value === 'object') {
        value = value.id || JSON.stringify(value); 
      }
      
      query += key + '=' + encodeURIComponent(value) + '&';
    }
    query = query.slice(0, -1);


    try {
      const response = await axios.post(entity + '/create'+query, jsonData);
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  read: async ({ entity, id }) => {
    console.log("*****Url of read Asinc ="+entity);
    try {
      const response = await axios.get(entity + '/read/' + id);
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      console.log("*****Url of read Asinc ="+response.data);
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  update: async ({ entity, options = {}, id, jsonData }) => {
    try {
      const response = await axios.patch(entity + '/update/' + id, jsonData);
      
      // Si el servidor responde correctamente (200), imprimamos qué trae:
      console.log("Respuesta real del servidor:", response.data);
      
      // Si tu backend devuelve un objeto que contiene los datos, intenta esto:
      return response.data.result || response.data.data || response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

delete: async ({ entity, id, options = {} }) => {
    console.log("delete")
    try {
      // 1. Identificamos si es cualquiera de tus tres nuevas tablas generadas
      const esNuevaEntidad = entity && (
        entity.includes('ainope') || 
        entity.includes('accope') || 
        entity.includes('acpope')||
        entity.includes('ainppre')||
        entity.includes('ainpmar')||
        entity.includes('ainpcat')||
        entity.includes('ainptax')||
        entity.includes('acccli') ||
        entity.includes('ainpro') ||
        entity.includes('acccsec')||
        entity.includes('empresas')||
        entity.includes('acppro')  ||
        entity.includes('accven')  ||
        entity.includes('acmp')    ||
        entity.includes('configuracion') 
      );
      

      
      // 2. Si es una de las nuevas, va directo al ID sin '/delete/'. Si no, mantiene el formato viejo.
      const url = esNuevaEntidad ? `${entity}/${id}` : `${entity}/delete/${id}`;
      
      console.log("🚀 URL Final de borrado calculada:", url);

      const response = await axios.delete(url);
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  filter: async ({ entity, options = {} }) => {
    console.log("*****Url of filter Asinc ="+entity);
    try {
      let filter = options.filter ? 'filter=' + options.filter : '';
      let equal = options.equal ? '&equal=' + options.equal : '';
      let query = `?${filter}${equal}`;

      const response = await axios.get(entity + '/filter' + query);
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  search: async ({ entity, options = {} }, options1 = {} ) => {
    console.log("*****Url of search Asinc ="+entity+" this option1 "+JSON.stringify(options1));
    try {
      let query = '?';
      for (var key in options) {
        query += key + '=' + options[key] + '&';
      }
      query = query.slice(0, -1);
      // headersInstance.cancelToken = source.token;
      const response = await axios.get(entity + '/search' + query);

     // console.log("*****Url of Search Asinc ="+API_BASE_URL+entity+'/search' + query);

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
    //  console.log("*****Url of Search Response Data="+JSON.stringify(response.data));
      
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  list: async ({ entity, options = {} }) => {
      
    try {

      let query = '?';
      for (var key in options) {
        query += key + '=' + options[key] + '&';
      }
      query = query.slice(0, -1);

     // console.log("*****Url of list Asinc ="+API_BASE_URL+entity+'/list' + query);

      const response = await axios.get(entity + '/list' + query);

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });

     /* let dato = response.data.result;

      dato2 = "";
      for(var k in dato) {
        console.log(k);
        dato2 
      }*/

      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  post: async ({ entity, jsonData, options = {} }) => {
    console.log("*****Url of post  Asinc ="+entity);
    try {
      const response = await axios.post(entity, jsonData);

      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  get: async ({ entity }) => {
    console.log("*****Url of get Asinc ="+entity);
    try {
      const response = await axios.get(entity);
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  patch: async ({ entity, jsonData }) => {
    console.log("*****Url of patch Asinc ="+entity);
    try {
      const response = await axios.patch(entity, jsonData);
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  source: () => {
    console.log("*****Url of source Asinc =");
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    return source;
  },
};
export default request;